import React from 'react';

class NotFound extends React.Component {
	render() {
		return (
			<div className="login-box">
				<div className="login-logo">
					<img alt="Richardson Sales Performance" src="/dist/img/richardson_sp.png" loading="lazy" />
				</div>
				<div className="login-body">
					<p>Sorry but we couldn't find the page you were looking for</p>
					<div className="mt20">
						<a href="/" className="btn btn-primary">
							<i className="fa fa-arrow-left mr5" />
							Back to home
						</a>
					</div>
				</div>
			</div>
		);
	}
}

export default NotFound;
